import { BsPersonBadge } from "react-icons/bs";
import { MdWorkOutline, MdOutlineFindInPage } from "react-icons/md";
// import { RiContactsBookLine } from "react-icons/ri";
import { TbMessages } from "react-icons/tb";

export const cards = (user) => [
  {
    id: 1,
    icon: BsPersonBadge,
    title: "recruiter",
    path: "/recruitment/manage",
    description: "manage_recruiter",
    disabled: !user.isHead,
  },
  {
    id: 3,
    icon: BsPersonBadge,
    title: "clients",
    path: "/recruitment/preManageClient",
    description: "manage_client_data",
    disabled: !user.isHead,
  },
  {
    id: 2,
    icon: MdWorkOutline,
    title: "job_assignment",
    path: "/recruiter/jobs",
    description: "assigning_the_job_for_the_recruiters",
    disabled: user.isHead,
  },
  // {
  //   id: 2,
  //   icon: RiContactsBookLine,
  //   title: "Contacts",
  //   path: "/recruitment/contacts",
  //   description: "Manage contact person information",
  // },
  {
    id: 4,
    icon: MdWorkOutline,
    title: "jobs",
    path: "/recruitment/preManageJobs",
    description: "manage_the_jobs",
    disabled: !user.isHead,
  },
  {
    id: 5,
    icon: TbMessages,
    title: "interview",
    path: "/recruitment/interviews",
    description: "manage_interview_information",
    disabled: !user.isHead,
  },
  {
    id: 6,
    icon: TbMessages,
    title: "trackers",
    path: "/recruitment/tracker",
    description: "manage_tracker",
    // disabled: !user.isHead,
  },
  {
    id: 7,
    icon: MdOutlineFindInPage,
    title: "resumes",
    path: "/recruitment/resumes",
    description: "oman_job_resumes_of_the_candidates",
  },
  // {
  //   id: 8,
  //   icon: MdOutlineFindInPage,
  //   title: "cv_batch",
  //   path: "/recruitment/cvBatch",
  //   description: "cv_batch_of_the_candidates",
  // },
  {
    id: 8,
    icon: MdOutlineFindInPage,
    title: "cv_batch",
    path: "/recruitment/cvBatch1",
    description: "cv_batch_of_the_candidates",
  },
  {
    id: 9,
    icon: MdOutlineFindInPage,
    title: "logs",
    path: "/recruitment/logs",
    description: "manage_logs",
  },
  {
    id: 10,
    icon: MdOutlineFindInPage,
    title: "Recruitment Head User Guide",
    path: "/recruitment/documentManage",
    description: "Recruitment Head User Guide",
    validFileExtension: ['.pdf'],
    disabled: !user.isHead,
  },
  {
    id: 11,
    icon: MdOutlineFindInPage,
    title: "Recruitment Head Work Process",
    path: "/recruitment/documentManage",
    description: "Recruitment Head Work Process",
    validFileExtension: ['.pdf'],
    disabled: !user.isHead,
  },
  {
    id: 12,
    icon: MdOutlineFindInPage,
    title: "Recruitment Policy",
    path: "/recruitment/documentManage",
    description: "Recruitment Policy",
    validFileExtension: ['.pdf'],
    disabled: !user.isHead,
  },
  {
    id: 13,
    icon: MdOutlineFindInPage,
    title: "Recruiters Targets",
    path: "/recruitment/documentManage",
    description: "Recruiters Targets",
    validFileExtension: ['.pdf', 'docx', 'doc', 'xlsx', 'xls'],
    disabled: !user.isHead,
  },
  {
    id: 14,
    icon: MdOutlineFindInPage,
    title: "Recruiter Daily Work",
    path: "/recruitment/documentManage",
    description: "Recruiter Daily Work Checkpoints Report",
    validFileExtension: ['.pdf'],
    disabled: !user.isHead,
  },
  {
    id: 15,
    icon: MdOutlineFindInPage,
    title: "My Daily Work Report",
    path: "/recruitment/documentManage",
    description: "My Daily Work Report",
    validFileExtension: ['.pdf'],
    disabled: !user.isHead,
  },
  {
    id: 16,
    icon: MdOutlineFindInPage,
    title: "Recruiter User Guide",
    path: "/recruitment/documentManage",
    description: "Recruiter User Guide",
    disabled: user.isHead,
  },
  {
    id: 17,
    icon: MdOutlineFindInPage,
    title: "Recruiter Work Process",
    path: "/recruitment/documentManage",
    description: "Recruiter Work Process",
    disabled: user.isHead,
  },
  {
    id: 18,
    icon: MdOutlineFindInPage,
    title: "Recruiter Communication Process",
    path: "/recruitment/documentManage",
    description: "Recruiter Communication Process",
    disabled: user.isHead,
  },
  {
    id: 19,
    icon: MdOutlineFindInPage,
    title: "My Targets",
    path: "/recruitment/documentManage",
    description: "My Targets",
    disabled: user.isHead,
  },

];

export const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

export const item = {
  hidden: {
    opacity: 0,
    y: "100px",
  },
  show: {
    opacity: 1,
    y: "0px",
    delay: 1,
    transition: {
      type: "spring",
      stiffness: 40,
      damping: 9,
    },
  },
};
